import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {httpUpdateReferringSpecialist, HttpUpdateReferringSpecialistPayload} from '../http/referring-specialists.http'
import {ReferringSpecialist} from '@/features/referring-specialists/types'

export const useUpdateReferringSpecialist = (
    options?: UseMutationOptions<
        ReferringSpecialist,
        unknown,
        {payload: HttpUpdateReferringSpecialistPayload; id: string}
    >
) => {
    const queryClient = useQueryClient()
    return useMutation({
        ...options,
        mutationFn: ({payload, id}) => httpUpdateReferringSpecialist({urlParams: {referringSpecialistId: id}, payload}),
        onSuccess: async (data, variables, context) => {
            await queryClient.invalidateQueries({queryKey: ['referring-specialists']})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
